<div class="d-flex flex-column justify-content-start align-items-stretch h-100 w-100 my-3">

    <app-spinner [isLoading]="isLoadingData" [isFullScreen]="false"></app-spinner>

    <div *ngIf="!isLoadingData" class="container-fluid p-4">

        <p-message
            styleClass="w-100"
            *ngIf="loadingMessage.show"
            [severity]="loadingMessage.severity"
            [text]="loadingMessage.text">
        </p-message>

        <div *ngIf="enrollmentPaymentInfo">

            <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-4">

                <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-2">
                    <span class="fs-5 text-primary-color fw-bolder" [innerHTML]="labels.stepTitleLabel"></span>
                    <span class="fs-6" [innerHTML]="labels.stepSubtitleLabel"></span>
                </div>

                <div class="summary-table w-100 mb-2">

                    <table class="table table-bordered">

                        <tbody *ngFor="let class of enrollmentClasses">

                            <tr>
                                <td class="table-period-title" colspan="3">
                                    <span class="fw-bold">{{ class.schedule.description }}</span>
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <span>Curso</span>
                                </td>
                                <td>
                                    <span>{{ class.courseName }} [{{ class.classification.name }}]</span>
                                </td>
                                <td class="text-end">
                                    <span class="fw-bold">{{ class.price }} €</span>
                                </td>
                            </tr>

                            <tr *ngFor="let extra of class.extraServices">
                                <td>
                                    <span>Extra</span>
                                </td>
                                <td>
                                    <span>{{ extra.displayName }}</span>
                                </td>
                                <td class="text-end">
                                    <span class="fw-bold">{{ extra.price }} €</span>
                                </td>
                            </tr>

                        </tbody>

                    </table>

                </div>

                <div class="payment-table w-100">

                    <table class="table table-bordered">

                        <tbody>

                            <tr>
                                <td class="table-payment-title" colspan="3">
                                    <span class="fw-bold">Resumen del pago:</span>
                                </td>
                            </tr>

                            <tr>
                                <td colspan="2">
                                    <span>Total de los cursos:</span>
                                </td>
                                <td class="text-end">
                                    <span class="fw-bold">{{enrollmentPaymentInfo.totalPriceCourses}} €</span>
                                </td>
                            </tr>

                            <tr *ngIf="enrollmentTotalDiscount > 0">
                                <td colspan="2">
                                    <span>Descuento aplicado: </span>
                                </td>
                                <td class="text-end">
                                    <span class="fw-bold">-{{enrollmentPaymentInfo.discountPriceCourses}} €</span>
                                </td>
                            </tr>

                            <tr *ngIf="enrollmentExtras && enrollmentExtras.length > 0">
                                <td colspan="2">
                                    <span>Total de los extras:</span>
                                </td>
                                <td class="text-end">
                                    <span class="fw-bold">{{enrollmentPaymentInfo.totalPriceExtras}} €</span>
                                </td>
                            </tr>

                            <tr>
                                <td class="table-total-title" colspan="2">
                                    <span class="fs-5 fw-bold" >TOTAL INSCRIPCIÓN</span>
                                </td>
                                <td class="table-total-title text-end">
                                    <span class="fw-bold">{{enrollmentPaymentInfo.finalPriceEnrollment}} €</span>
                                </td>
                            </tr>

                        </tbody>

                    </table>


                </div>

            </div>

        </div>

    </div>

</div>
